import { Market, SelectionType, MarketIdToMarketType } from "../../data";
import { SelectionParser, SelectionSortFuncs } from "../SelectionParser";
export class MarketParser {
    constructor() {
        this.ExtractEachWayFromSelectionNameRegex = /E\/W \d+\/\d+ (\d+-{1})+(\d+)+/;
    }
    static get instance() {
        if (!MarketParser._instance) {
            MarketParser._instance = new MarketParser();
        }
        return MarketParser._instance;
    }
    parse(source, existingMarket, uiPreferences) {
        const propsFromExistingMarket = this.getPropsFromExistingMarket(source, existingMarket);
        const marketType = propsFromExistingMarket.marketType;
        return new Market({
            id: source.id,
            type: this.getMarketType(marketType),
            typeId: marketType,
            selections: source.selections.map((x) => SelectionParser.instance.parse(x, propsFromExistingMarket.selections.find(sel => sel.id === x.id), uiPreferences))
                .filter(x => !x.isDisabled && x.odds)
                .sort(SelectionSortFuncs.Sort(this.getMarketType(marketType))),
            name: source.name,
            eachWayText: propsFromExistingMarket.eachWayText,
            tags: source.tags,
            betslipLine: source.betslipLine,
            isLive: propsFromExistingMarket.isLive
        });
    }
    getEachWay(market) {
        for (let index = 0; index < market.selections.length; index++) {
            let currentMatch = market.selections[index]
                .name.match(this.ExtractEachWayFromSelectionNameRegex);
            if (currentMatch !== null) {
                return currentMatch[0];
            }
        }
        return undefined;
    }
    getMarketType(marketType) {
        return MarketIdToMarketType[marketType] || SelectionType.QA;
    }
    getPropsFromExistingMarket(source, existingMarket) {
        return existingMarket
            ? {
                selections: existingMarket.selections,
                marketType: existingMarket.typeId,
                eachWayText: existingMarket.eachWayText,
                isLive: existingMarket.isLive
            }
            : {
                selections: [],
                marketType: source.marketType.id,
                eachWayText: this.getEachWay(source),
                isLive: source.isLive
            };
    }
}
//# sourceMappingURL=MarketParser.js.map